var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { decode } from "he";
import isValidAbsoluteUrl from "validator/lib/isURL";
const decodeChildren = (children) => {
    if (typeof children === "string") {
        return decode(children);
    }
    return children;
};
export const Anchor = (_a) => {
    var { children, testId } = _a, anchorProps = __rest(_a, ["children", "testId"]);
    const { href } = anchorProps;
    const TRUSTED_HOSTS = ["id.atlassian.com", "id.stg.internal.atlassian.com"];
    const decodedChildren = decodeChildren(children);
    if (!href) {
        // Remove empty string `href` from render if present
        const { href: emptyHref } = anchorProps, rest = __rest(anchorProps, ["href"]);
        return (_jsx("span", Object.assign({}, rest, { "data-testid": testId, children: decodedChildren })));
    }
    else if (isValidAbsoluteUrl(href)) {
        const { host } = new URL(href);
        const isTrustedUrl = TRUSTED_HOSTS.includes(host);
        return (_jsx("a", Object.assign({}, anchorProps, { target: isTrustedUrl ? undefined : "_blank", rel: isTrustedUrl ? undefined : "noopener", "data-testid": testId, children: decodedChildren })));
    }
    else if (href.startsWith("#") || href.startsWith("mailto:")) {
        return (_jsx("a", Object.assign({}, anchorProps, { "data-testid": testId, children: decodedChildren })));
    }
    else {
        return (_jsx("a", Object.assign({}, anchorProps, { "data-testid": testId, href: href, children: decodedChildren })));
    }
};
//# sourceMappingURL=Anchor.js.map